module.exports = __webpack_public_path__ + "static/media/software.8e965cab.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/home/software.png
 ** module id = 636
 ** module chunks = 0
 **/